<template>
  <div v-if="mostrar" class="modal-overlay">
    <div class="modal-container">
      <!-- Cabeçalho -->
      <div class="modal-header d-flex align-items-center justify-content-between">
        <h5 class="mb-0">Ajustar Datas (Regras Inversas)</h5>
        <button class="btn btn-sm btn-outline-secondary" @click="$emit('fechar')">
          Fechar
        </button>
      </div>

      <!-- Conteúdo -->
      <div class="modal-body">
        <!-- Filtros -->
        <div class="card p-3 mb-3">
          <div class="row g-3 align-items-end">
            <div class="col-md-3">
              <label class="form-label">De (data_recebimento)</label>
              <input type="date" class="form-control" v-model="filtros.from" />
            </div>
            <div class="col-md-3">
              <label class="form-label">Até (data_recebimento)</label>
              <input type="date" class="form-control" v-model="filtros.to" />
            </div>

            <div class="col-md-3">
              <label class="form-label">Matrícula ID</label>
              <input type="number" min="1" class="form-control" v-model.number="filtros.matricula_id" placeholder="Opcional" />
            </div>

            <div class="col-md-3">
              <label class="form-label">Contrato</label>
              <input type="text" class="form-control" v-model.trim="filtros.contrato" placeholder="Opcional" />
            </div>

            <div class="col-md-6">
              <label class="form-label d-flex align-items-center justify-content-between">
                <span>Formas de Pagamento</span>
                <div class="d-flex" style="gap:.35rem;">
                  <button class="btn btn-sm btn-outline-secondary" @click="selecionarTodasFormas" type="button">Selecionar todas</button>
                  <button class="btn btn-sm btn-outline-secondary" @click="limparFormas" type="button">Limpar</button>
                </div>
              </label>
              <select class="form-select" multiple size="6" v-model="filtros.formas_ids">
                <option v-for="fp in formasPagamento" :key="fp.id" :value="fp.id">
                  {{ fp.nome }} <span v-if="typeof fp.prazo_pagamento === 'number'"> ({{ fp.prazo_pagamento }}d)</span>
                </option>
              </select>
              <div class="form-text">
                Dica: segure Ctrl (ou Cmd) para multisseleção.
              </div>
            </div>

            <div class="col-md-6">
              <div class="row g-3">
                <div class="col-12">
                  <label class="form-label d-block">Alcance</label>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="checkbox" id="mensalidade" v-model="filtros.incluir_mensalidade">
                    <label class="form-check-label" for="mensalidade">Parcelas de mensalidade</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="checkbox" id="matricula" v-model="filtros.incluir_matricula">
                    <label class="form-check-label" for="matricula">Pagamento de matrícula (pgt_matricula)</label>
                  </div>
                </div>

                <div class="col-12">
                  <label class="form-label d-block">Regras</label>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="considerarHolidays" v-model="filtros.considerar_feriados_df">
                    <label class="form-check-label" for="considerarHolidays">
                      Considerar feriados do DF (empurrar recebimento para próximo dia útil na lógica de ida – preview/servidor aplicam a regra inversa canônica)
                    </label>
                  </div>
                </div>

                <div class="col-12">
                  <label class="form-label d-block">Exibição</label>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="checkbox" id="somenteAlteracoes" v-model="somenteAlteracoes">
                    <label class="form-check-label" for="somenteAlteracoes">Mostrar somente linhas que mudariam</label>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div class="d-flex align-items-center mt-3" style="gap:.5rem;">
            <button class="btn btn-primary" :disabled="loadingPreview" @click="visualizarAlteracoes">
              <i class="bi bi-search me-1"></i> Visualizar alterações
            </button>

            <button class="btn btn-outline-secondary" :disabled="!previewLoaded || !diffs.length" @click="exportarCSV">
              <i class="bi bi-filetype-csv me-1"></i> Exportar CSV
            </button>

            <div class="ms-auto">
              <button
                class="btn btn-success"
                :disabled="!previewLoaded || !podeAplicar || loadingApply"
                @click="aplicarAjustes"
                title="Executa UPDATE em transação única"
              >
                <i class="bi bi-check2-circle me-1"></i> Aplicar ajustes
              </button>
            </div>
          </div>
        </div>

        <!-- KPIs -->
        <div v-if="previewLoaded" class="row g-3 mb-2">
          <div class="col-md-3">
            <div class="kpi-card">
              <div class="kpi-label">Avaliadas</div>
              <div class="kpi-value">{{ resumo.total_avaliadas }}</div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="kpi-card">
              <div class="kpi-label">Serão alteradas</div>
              <div class="kpi-value text-success">{{ resumo.total_alteradas }}</div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="kpi-card">
              <div class="kpi-label">Mantidas</div>
              <div class="kpi-value">{{ resumo.total_mantidas }}</div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="kpi-card">
              <div class="kpi-label">Puladas</div>
              <div class="kpi-value text-muted">{{ resumo.total_puladas }}</div>
            </div>
          </div>
        </div>

        <!-- Tabela de diffs -->
        <div v-if="previewLoaded" class="table-responsive">
          <table class="table table-sm table-striped align-middle">
            <thead>
              <tr>
                <th style="min-width: 80px;">ID</th>
                <th style="min-width: 110px;">Tipo</th>
                <th style="min-width: 180px;">Forma</th>
                <th style="min-width: 125px;">Recebimento</th>
                <th style="min-width: 220px;">Pagamento</th>
                <th style="min-width: 220px;">Vencimento</th>
                <th style="min-width: 240px;">Motivo</th>
                <th style="min-width: 220px;">Cliente pagou (primeira) </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in paginaItens" :key="item.id">
                <td>{{ item.id }}</td>
                <td>
                  <span :class="item.tipo==='mensalidade' ? 'badge bg-secondary' : 'badge bg-info'">
                    {{ item.tipo }}
                  </span>
                </td>
                <td>{{ item.forma_nome }}</td>
                <td>{{ fmtData(item.data_recebimento) }}</td>
                <td>
                  <span :class="classeDiff(item.data_pagamento_atual, item.data_pagamento_nova)">
                    {{ fmtData(item.data_pagamento_atual) }} → <strong>{{ fmtData(item.data_pagamento_nova) }}</strong>
                  </span>
                </td>
                <td>
                  <span :class="classeDiff(item.data_vencimento_atual, item.data_vencimento_nova)">
                    {{ fmtData(item.data_vencimento_atual) }} → <strong>{{ fmtData(item.data_vencimento_nova) }}</strong>
                  </span>
                </td>
                <td>{{ item.motivo || '–' }}</td>
                <td>
                    <span :class="classeDiff(item.data_cliente_pagou_atual, item.data_cliente_pagou_nova)">
                        {{ fmtData(item.data_cliente_pagou_atual) }} → <strong>{{ fmtData(item.data_cliente_pagou_nova) }}</strong>
                    </span>
                </td>

              </tr>
              <tr v-if="!paginaItens.length">
                <td colspan="7" class="text-center text-muted py-3">
                  Nenhuma alteração a exibir para os filtros selecionados.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Paginação local -->
        <div v-if="previewLoaded" class="d-flex align-items-center justify-content-between">
          <div class="text-muted small">
            Mostrando {{ startRow }} a {{ endRow }} de {{ diffsFiltrados.length }} alterações
          </div>
          <div class="d-flex align-items-center" style="gap:.5rem;">
            <select class="form-select form-select-sm" style="width: 6rem" v-model.number="limite" @change="pagina=1">
              <option v-for="n in [10,20,50,100,200]" :key="n" :value="n">{{ n }}/pág</option>
            </select>
            <nav>
              <ul class="pagination pagination-sm mb-0">
                <li class="page-item" :class="{disabled: pagina<=1}">
                  <button class="page-link" @click="pagina > 1 && (pagina--)" :disabled="pagina<=1">«</button>
                </li>
                <li class="page-item disabled"><span class="page-link">{{ pagina }} / {{ totalPaginas }}</span></li>
                <li class="page-item" :class="{disabled: pagina>=totalPaginas}">
                  <button class="page-link" @click="pagina < totalPaginas && (pagina++)" :disabled="pagina>=totalPaginas">»</button>
                </li>
              </ul>
            </nav>
          </div>
        </div>

      </div>

      <!-- Rodapé -->
      <div class="modal-footer d-flex justify-content-between">
        <small class="text-muted">
          Somente administradores podem aplicar. O preview não altera dados.
        </small>
        <div>
          <button class="btn btn-outline-secondary me-2" @click="$emit('fechar')">Cancelar</button>
          <button class="btn btn-success" :disabled="!previewLoaded || !podeAplicar || loadingApply" @click="aplicarAjustes">
            <i class="bi bi-check2-circle me-1"></i> Aplicar ajustes
          </button>
        </div>
      </div>

      <!-- Loading overlay -->
      <div v-if="loadingPreview || loadingApply" class="busy-overlay">
        <div class="spinner-border" role="status"></div>
        <div class="mt-2">{{ loadingApply ? 'Aplicando ajustes…' : 'Calculando preview…' }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/services/axios';
import globalUtils from '@/utils/globalUtils.js';

export default {
  name: 'ModalAjustarDatas',
  props: {
    mostrar: { type: Boolean, default: false }
  },
  emits: ['fechar', 'aplicou'],
  data() {
    return {
      // filtros
      filtros: {
        from: '',
        to: '',
        formas_ids: [],
        incluir_mensalidade: true,
        incluir_matricula: true,
        considerar_feriados_df: true,
        matricula_id: null,
        contrato: ''
      },
      formasPagamento: [],
      // preview/diffs
      previewLoaded: false,
      resumo: {
        total_avaliadas: 0,
        total_alteradas: 0,
        total_mantidas: 0,
        total_puladas: 0
      },
      diffs: [],
      // paginação local
      pagina: 1,
      limite: 20,
      somenteAlteracoes: true,
      // loading
      loadingPreview: false,
      loadingApply: false,
      globalUtils
    };
  },
  computed: {
    diffsFiltrados() {
      if (!this.somenteAlteracoes) return this.diffs;
      return this.diffs.filter(it =>
        (it.data_pagamento_atual !== it.data_pagamento_nova) ||
        (it.data_vencimento_atual !== it.data_vencimento_nova)
      );
    },
    totalPaginas() {
      return Math.max(1, Math.ceil(this.diffsFiltrados.length / this.limite));
    },
    paginaItens() {
      const start = (this.pagina - 1) * this.limite;
      return this.diffsFiltrados.slice(start, start + this.limite);
    },
    startRow() {
      if (!this.diffsFiltrados.length) return 0;
      return (this.pagina - 1) * this.limite + 1;
    },
    endRow() {
      return Math.min(this.pagina * this.limite, this.diffsFiltrados.length);
    },
    podeAplicar() {
      // só permite aplicar se houver o que mudar
      return this.resumo.total_alteradas > 0 && this.ehAdmin();
    }
  },
  watch: {
    mostrar(val) {
      if (val) {
        this.bootstrap();
      } else {
        // reset leve quando fechar
        this.previewLoaded = false;
        this.diffs = [];
        this.resumo = { total_avaliadas: 0, total_alteradas: 0, total_mantidas: 0, total_puladas: 0 };
        this.pagina = 1;
      }
    }
  },
  methods: {
    async bootstrap() {
      await this.carregarFormasPagamento();
      // defaults de período (últimos 90 dias)
      if (!this.filtros.to) {
        const hoje = new Date();
        this.filtros.to = hoje.toISOString().slice(0, 10);
      }
      if (!this.filtros.from) {
        const d = new Date(this.filtros.to + 'T00:00:00');
        d.setDate(d.getDate() - 90);
        this.filtros.from = d.toISOString().slice(0, 10);
      }
    },

    ehAdmin() {
      const gp = this?.$root?.$?.appContext?.config?.globalProperties;
      const perms = gp?.$globalState?.userPermissions || [];
      const perfil = gp?.$globalState?.userProfile;
      const asStr = typeof perfil === 'string' ? perfil : (perfil?.perfil || perfil?.role || '');
      const hasPerm = Array.isArray(perms)
        ? perms.map(s => String(s).toLowerCase().trim()).includes('administrador')
        : false;
      const byTitle = /(^|\s)(administrador|admin)(\s|$)/i.test(String(asStr || '').trim());
      const isFlag = !!gp?.$globalState?.isAdmin;
      return hasPerm || byTitle || isFlag;
    },

    async carregarFormasPagamento() {
      try {
        const { data } = await axios.get('/cadastros/formas-pagamento');
        const arr = Array.isArray(data) ? data : (data?.data ?? []);
        this.formasPagamento = arr.map(fp => ({
          id: fp.id,
          nome: fp.nome,
          prazo_pagamento: fp.prazo_pagamento ?? null
        })).filter(fp => (fp.nome || '').toLowerCase().trim() !== 'brinde');
      } catch (e) {
        console.error('Erro ao carregar formas de pagamento:', e);
        this.formasPagamento = [];
      }
    },

    selecionarTodasFormas() {
      this.filtros.formas_ids = this.formasPagamento.map(f => f.id);
    },

    limparFormas() {
      this.filtros.formas_ids = [];
    },

    paramsPreview() {
      const p = {
        from: this.filtros.from || undefined,
        to: this.filtros.to || undefined,
        incluirMensalidade: this.filtros.incluir_mensalidade ? 'true' : 'false',
        incluirMatricula: this.filtros.incluir_matricula ? 'true' : 'false',
        considerarFeriadosDF: this.filtros.considerar_feriados_df ? 'true' : 'false',
        matricula_id: this.filtros.matricula_id || undefined,
        contrato: (this.filtros.contrato || '').trim() || undefined,
      };
      if (this.filtros.formas_ids.length) {
        p.formas = this.filtros.formas_ids.join(',');
      }
      return p;
    },

    async visualizarAlteracoes() {
      this.loadingPreview = true;
      this.previewLoaded = false;
      this.diffs = [];
      this.resumo = { total_avaliadas: 0, total_alteradas: 0, total_mantidas: 0, total_puladas: 0 };
      this.pagina = 1;

      try {
        const res = await axios.get('/operacional/pagamentos-matriculas/ajustar-datas/preview', {
          params: this.paramsPreview()
        });
        const payload = res.data || {};
        // forma esperada:
        // { total_avaliadas, total_alteradas, total_mantidas, total_puladas, itens: [...] }
        this.resumo.total_avaliadas = Number(payload.total_avaliadas || 0);
        this.resumo.total_alteradas = Number(payload.total_alteradas || 0);
        this.resumo.total_mantidas  = Number(payload.total_mantidas  || 0);
        this.resumo.total_puladas   = Number(payload.total_puladas   || 0);
        this.diffs = Array.isArray(payload.itens) ? payload.itens : [];
        this.previewLoaded = true;
      } catch (e) {
        console.error('Erro no preview de ajustes:', e);
        this.$toast?.error?.('Falha ao calcular o preview de ajustes.');
      } finally {
        this.loadingPreview = false;
      }
    },

    async aplicarAjustes() {
      if (!this.podeAplicar) return;
      this.loadingApply = true;
      try {
        const res = await axios.post('/operacional/pagamentos-matriculas/ajustar-datas/apply', this.paramsPreview());
        // forma esperada: { alteradas, inalteradas, puladas, job_id }
        const r = res.data || {};
        this.$toast?.success?.(`Ajustes aplicados: ${r.alteradas ?? 0} alteradas, ${r.inalteradas ?? 0} mantidas.`);
        this.$emit('aplicou');
      } catch (e) {
        console.error('Erro ao aplicar ajustes:', e);
        this.$toast?.error?.('Falha ao aplicar ajustes.');
      } finally {
        this.loadingApply = false;
      }
    },

    fmtData(d) {
      return d ? this.globalUtils.formatarData(d) : '—';
    },

    classeDiff(atual, nova) {
      return (atual !== nova) ? 'text-success' : 'text-muted';
    },

    exportarCSV() {
        const rows = [
        [
            'id','matricula_id','tipo','forma_nome','data_recebimento',
            'data_pagamento_atual','data_pagamento_nova',
            'data_vencimento_atual','data_vencimento_nova',
            'data_cliente_pagou_atual','data_cliente_pagou_nova',
            'motivo'
        ],
        ...this.diffsFiltrados.map(it => [
            it.id,
            it.matricula_id,
            it.tipo,
            it.forma_nome,
            it.data_recebimento || '',
            it.data_pagamento_atual || '',
            it.data_pagamento_nova || '',
            it.data_vencimento_atual || '',
            it.data_vencimento_nova || '',
            it.data_cliente_pagou_atual || '',
            it.data_cliente_pagou_nova || '',
            (it.motivo || '').replace(/\s+/g, ' ')
        ])
        ];
      const csv = rows.map(r => r.map(v => {
        const s = String(v ?? '');
        return /[",;\n]/.test(s) ? `"${s.replace(/"/g,'""')}"` : s;
      }).join(';')).join('\n');

      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      const dt = new Date().toISOString().replace(/[:.]/g,'-');
      a.download = `preview_ajustes_datas_${dt}.csv`;
      a.click();
      URL.revokeObjectURL(url);
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed; inset: 0;
  background: rgba(0,0,0,.35);
  display: flex; align-items: center; justify-content: center;
  z-index: 2000;
}
.modal-container {
  width: min(100%, 96vw);
  max-height: 92vh;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0,0,0,.2);
  position: relative;
  display: flex; flex-direction: column;
}
.modal-header, .modal-footer {
  padding: .75rem 1rem;
  border-bottom: 1px solid #eee;
}
.modal-footer { border-top: 1px solid #eee; border-bottom: 0; }
.modal-body {
  padding: 1rem;
  overflow: auto;
}
.kpi-card {
  background: #f8f9fa;
  border: 1px solid #eee;
  border-radius: 8px;
  padding: .75rem;
}
.kpi-label { font-size: .8rem; color: #666; }
.kpi-value { font-size: 1.1rem; font-weight: 600; }
.busy-overlay {
  position: absolute; inset: 0;
  background: rgba(255,255,255,.8);
  display: flex; flex-direction: column;
  align-items: center; justify-content: center;
  z-index: 5;
}
.badge { text-transform: capitalize; }
</style>
